import { FC } from 'react'
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { confirmStyle } from './Confirm.style'

export interface ConfirmProps {
  open: boolean
  text: string
  handleConfirm: () => void
  handleCancel: () => void
}

const defaultProps: ConfirmProps = {
  open: true,
  text: '',
  handleConfirm: () => {},
  handleCancel: () => {}
}

/**
 * Confirm React component.
 * The following properties are implemented:
 * visible {boolean}: If true the component is visible.
 * handleConfirm {function}: Handle "OK" click.
 * handleCancel {function}: Handle "Cancel" click.
 * @param props React properties object.
 * @returns React view component.
 */
export const Confirm: FC<ConfirmProps> = (props: ConfirmProps) => {
  const classes = confirmStyle()
  return (
    <Dialog
      open={props.open}
      onClose={() => props.handleCancel()}
      aria-labelledby='confirm-dialog'
    >
      <DialogTitle id='confirm-dialog'><FormattedMessage id='common.warning' /></DialogTitle>
      <DialogContent>
        {props.text}
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          onClick={() => props.handleCancel()}
          color='default'
        >
          <FormattedMessage id='common.cancel' />
        </Button>
        <Button
          variant='contained'
          onClick={() => {
            props.handleConfirm()
          }}
          color='primary'
          className={classes.confirmButton}
        >
          <FormattedMessage id='common.ok' />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

Confirm.defaultProps = defaultProps

export default Confirm
